import React from 'react';
import ReactDOM from 'react-dom';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import styles from './StudentMetricsDashboardTools.module.scss';

interface StudentMetricsDashboardToolsProps {
  toolsContainer?: any;
  totalStudents: number;
  onExportData?: () => void;
  title?: string;
}

const StudentMetricsDashboardTools: React.FC<StudentMetricsDashboardToolsProps> = ({
  toolsContainer,
  totalStudents,
  onExportData,
  title,
}) => {
  const { t } = useAdminTranslation();

  return toolsContainer ? (
    ReactDOM.createPortal(
      <div className={styles.tools}>
        {totalStudents > 0 && (
          <span className={styles.totalStudents}>
            {title || t('studentMetricsDashboard.totalStudents', { totalStudents })}
          </span>
        )}
        {onExportData && (
          <button className={styles.exportData} onClick={onExportData}>
            {t('studentMetricsDashboard.exportData.button')}
          </button>
        )}
      </div>,
      toolsContainer
    )
  ) : (
    <></>
  );
};

export default StudentMetricsDashboardTools;
